import { Component, Input, OnInit } from '@angular/core';
import { ApiInfoService } from '../../modules/shared/services/api-info.service';
import { ApiInfo } from '../../models/api-info';
import { LogService } from 'src/app/modules/shared/services/log.service';
import * as jsonFooter from '../../../assets/config/footer.json';
import * as jsonLang from '../../../assets/config/lang.json';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() currentLanguageCode;
  @Input() currentLanguage;
  public columns;
  public apiInfo: ApiInfo;
  public footerItems = jsonFooter.config;
  public langueChoice = jsonLang.language;

  constructor(private apiInfoService: ApiInfoService, private LOG: LogService, public translate: TranslateService) {
  }

  ngOnInit() {
    this.apiInfo = new ApiInfo();
    this.getInfo();
    this.currentLanguage = 'language.french';
    this.currentLanguageCode = 'fr';
  }

  public getInfo() {
    this.apiInfoService.info().subscribe(data => {
      this.LOG.info('[FOOTER : {0}]', JSON.stringify(data));
      this.apiInfo.title = data.title;
      this.apiInfo.version = data.version;
      this.apiInfo.environment = data.environment;
    }, (err) => {
      this.apiInfo.title = 'unknown';
      this.apiInfo.version = 'unknown';
      this.apiInfo.environment = 'unknown';
    });
  }
}
